import { Modal } from "@common/Modal";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { BackgroundViewName } from "../types/BackgroundViewName";
import i18n from "@service/locale/i18";
import { Store } from "vuex";

type BroadcastQue = Record<string, { isLive: boolean; id: string }>;

export class BackgroundViewHelper {

    static getViewByRouteName(routeName: string): BackgroundViewName {
        switch (routeName) {
            case RouteNamesEnum.home:
                return BackgroundViewName.stage

            case RouteNamesEnum.viewMeeting:
            case RouteNamesEnum.viewMeetingPublic:
                return BackgroundViewName.meeting

            case RouteNamesEnum.appointment:
                return BackgroundViewName.appointment

            case RouteNamesEnum.viewSession:
                return BackgroundViewName.session
        }

        return BackgroundViewName.empty;
    }

    static getActiveBroadcastView(broadcastQue: BroadcastQue) {
        return Object.keys(broadcastQue)
            .find((viewName) => broadcastQue[viewName].isLive);
    }

    /**
     * Проверяет идет ли трансляция
     * @param broadcastQue
     * @param currentBroadcast
     * @param objectId - объект для которого осуществляется проверка на свободность трансляции
     * @returns
     */
    static checkBroadcastIsBusy(broadcastQue: BroadcastQue, currentBroadcast = "", objectId: string | null = null): boolean {
        return Object.keys(broadcastQue)
            .filter((viewName) => broadcastQue[viewName].isLive && viewName !== currentBroadcast && (objectId == null || broadcastQue[viewName].id != objectId))
            .map((viewName) => viewName).length > 0;
    }

    /**
     * Проверяет идет ли трансляция, если идет то показывает модальное окно о переходе и возвращает решение пользователя
     * если не занято возвращает true
     * @param store
     * @param objectId
     * @param viewName - экран для которого запрашивается показ трансляции
     * @returns
     */
    static async checkBroadcast(store: Store<any>, objectId: string, viewName: BackgroundViewName) {
        const isBusy = BackgroundViewHelper.checkBroadcastIsBusy(store.state.backgroundView.broadcastQue, '', objectId);

        let continueRequest = true;
        if (isBusy) {
            const confirmed = await BackgroundViewHelper.doConfirmModal();
            continueRequest = confirmed && confirmed !== "close";
            continueRequest && await store.dispatch("backgroundView/setOffline", viewName);
        }

        return continueRequest;
    }

    static async doConfirmModal() {
        const modal = new Modal({
            title: i18n.t('program.current live stream would be stopped').toString(),
            buttons: [
                {
                    text: i18n.t('common.yes').toString(),
                    class: 'is-green',
                    returnValue: true
                },
                {
                    text: i18n.t('common.no').toString(),
                    class: 'is-red is-outlined',
                    returnValue: false
                },
            ]
        });

        return await modal.showConfirm()
    }
}
